angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-top-traders-factory',
        function ($api, $factory) {
            $api.factory.topTraders = $factory;
        },
    ])
    .factory('graph-top-traders-factory', [
        '$q',
        'graph-api-client',
        function ($q, client) {
            return {
                query: function (space, options) {
                    return client.get(space, options);
                },
            };
        },
    ])
    .controller('topTradersCtrl', [
        '$scope',
        'graph-top-traders-factory',
        '$rootScope',
        function ($scope, $eventFactory, $rootScope) {
            $scope.topTradersFilter = false;
            $scope.filteredTopTraders = null;
            $scope.selectedCountFilter = '30';
            $scope.selectCount = [
                {
                    value: 30,
                    name: '30 Traders',
                },
                {
                    value: 60,
                    name: '60 Traders',
                },
                {
                    value: 90,
                    name: '90 Traders',
                },
                {
                    value: 180,
                    name: '180 Traders',
                },
            ];

            $scope.showFilter = function () {
                $rootScope.$broadcast('onClickOpenTopTradersFilter', false);
                $scope.topTradersFilter = true;

                let params = {
                    count: 30,
                };

                $eventFactory
                    .query('top/traders', {
                        params: params,
                    })
                    .then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            $scope.filteredTopTraders = response.data.data;
                        }
                    });
            };

            $scope.changeCountFilter = function (count) {
                let params = {
                    count: count,
                };

                $eventFactory
                    .query('top/traders', {
                        params: params,
                    })
                    .then(function (response) {
                        if (response.data.state === 0 && response.data.data.length > 0) {
                            $scope.filteredTopTraders = response.data.data;
                        }
                    });
            };

            $scope.hideFilter = function () {
                $rootScope.$broadcast('onClickOpenTopTradersFilter', true);
                $scope.topTradersFilter = false;
            };
        },
    ]);
